import React, { useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import clsx from 'clsx';

import './toolbar-dropdown.scss';

import APDropdown from 'components/Dropdown/APDropdown';
import { useTooltip } from '../toolbar/tooltip/Tooltip';


const ToolbarDropdown = ({
  isOpen,
  show,
  dismiss,
  name,
  DropdownButton,
  anchorElement,
  className,
  tooltipName,
  placement = 'bottom-start',
  children,
  tabIndex,
}) => {
  const [refElement, setRefElement] = useState(anchorElement);

  const {
    setCurrentTitle,
    setAnchor,
  } = useTooltip();

  const updateTooltip = () => {
    setCurrentTitle(tooltipName);
    setAnchor(refElement);
  };

  const resetTooltip = () => {
    setCurrentTitle(null);
    setAnchor(null);
  };

  // Add remaining props to passed trigger button component.
  const Button = DropdownButton ? React.cloneElement(
    DropdownButton,
    {
      setRef: setRefElement,
      isOpen,
      onClick: (e) => {
        if (isOpen) {
          dismiss(e);
        }
        else {
          show(e);
        }
      },
      onMouseDown: (e) => {
        e.preventDefault();
      },
      ... tooltipName && {
        onMouseEnter: () => updateTooltip(),
        onMouseMove: () => updateTooltip(),
        onMouseLeave: () => resetTooltip(),
      },
      ... tabIndex && {
        tabIndex,
      },
    },
  ) : null;

  return (
    <APDropdown
      isOpen={isOpen}
      show={show}
      dismiss={dismiss}
      triggerButton={Button}
      children={children}
      placement={placement}
      hasArrow
      className={className}
      dropDownClass='toolbar-dropdown__menu'
      menuClass={clsx(
        'toolbar-dropdown__content',
        name && `toolbar-dropdown__content--${name}`,
      )}
      name={name}
      scrollLockOnOpen={false}
      root={null}
      anchorElement={anchorElement}
    />
   );
};

export const ToolbarDropdownButton = ({
  isOpen,
  onClick,
  showIcon = false,
  className = '',
  setRef = null, // Used to stop click propagation in parent element.
  disabled = false,
  children,
  ...restProps
}) => {
  const renderArrow = () => {
    return isOpen ? <MdKeyboardArrowUp size={14} /> : <MdKeyboardArrowDown size={14} />;
  };

  return (
    <button
      ref={setRef}
      className={clsx(
        'button--unstyled',
        'no-padding',
        className,
        showIcon && 'has-icon',
      )}
      onClick={onClick}
      disabled={disabled}
      {...restProps}
      aria-expanded={isOpen}
    >
      <span className="toolbar-dropdown-button__content">
        {children}
        {showIcon && !disabled ? (
          renderArrow()
        ) : null }
      </span>
    </button>
  );
};

export default ToolbarDropdown;
